import client from '../client';
import type { ApiResponse } from '../../types/api';

// Product metafields are stored per namespace (a provider's appSlug). The
// fulfillment UI writes the chosen SKU + input-field mappings into the provider's
// namespace so the sourcing app can resolve them at order time.

export type Metafields = Record<string, unknown>;

export interface MetafieldsResponse {
  namespace: string;
  metafields: Metafields;
}

export const metafieldsApi = {
  get: async (storeId: string, productId: string, namespace: string): Promise<MetafieldsResponse> => {
    const res = await client.get<ApiResponse<MetafieldsResponse>>(
      `/dashboard/${storeId}/products/${productId}/metafields`,
      { params: { namespace } },
    );
    return res.data.data!;
  },

  /** Merge the given values into the namespace (partial update). */
  put: async (
    storeId: string,
    productId: string,
    namespace: string,
    values: Metafields,
  ): Promise<MetafieldsResponse> => {
    const res = await client.put<ApiResponse<MetafieldsResponse>>(
      `/dashboard/${storeId}/products/${productId}/metafields/${namespace}`,
      values,
    );
    return res.data.data!;
  },

  /** Remove the entire namespace from the product. */
  remove: async (storeId: string, productId: string, namespace: string): Promise<void> => {
    await client.delete<ApiResponse<{ namespace: string }>>(
      `/dashboard/${storeId}/products/${productId}/metafields/${namespace}`,
    );
  },
};
